import { MesFraisView } from "@features/home-dashboard/frais";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/(dashboard)/frais/me/")({
  staticData: {
    title: "Mes Frais",
    section: "Général",
    order: 40,
    showInTab: true,
    showInBreadcrumb: true,
  },
  component: FraisMeRoute,
});

function FraisMeRoute() {
  return <MesFraisView />;
}
